export enum RecordingError {
  MICROPHONE_WITH_ISSUE = 'MICROPHONE_DISCONNECTED',
  NO_AUDIO_IN_MIC = 'NO_AUDIO_IN_MIC',
  NO_AUDIO_IN_SPEAKER = 'NO_AUDIO_IN_SPEAKER',
}
